import React, { useEffect, useState } from "react";
import Loader from "../../lib/components/Loader";

import api from '../../utils/api';
import constants from "../../lib/constants";

const PlayoffDetailed = () => {
    const [playoffDetails, updatePlayoffDetails] = useState(null);
    const [playoffMatchups, updatePlayoffMatchups] = useState({});

    const [sortByDirection, updateSortByDirection] = useState(false);

    const sortableHeaderStyle = { cursor: 'pointer', fontSize: '0.85rem' };
    const headerStyle = { fontSize: '0.85rem' };
    const tdStyle = { fontSize: '12px' };

    useEffect(() => {
        // why? 
        const fetchData = async () => {
            const { data } = await api.get('/api/v1/history/playoffs/players');
            updatePlayoffDetails(data);
            const { data: matchupData } = await api.get('/api/v1/history/playoffs/matchups');
            updatePlayoffMatchups(matchupData);
        };

        fetchData();
    }, []);

    const sort = (sortBy) => () => {
        const sorted = playoffDetails.sort((a, b) => sortByDirection ? a[sortBy] - b[sortBy] : b[sortBy] - a[sortBy]);
        updateSortByDirection(!sortByDirection);
        updatePlayoffDetails([...sorted]);
    };

    const sortWithTwoOptions = (sortByAsc, sortByDesc) => () => {
        const sorted = playoffDetails.sort((a, b) => {
            if ( sortByDirection ) {
                if (b[sortByDesc] - a[sortByDesc] === 0) {
                    return a[sortByAsc] - b[sortByAsc];
                }
                return b[sortByDesc] - a[sortByDesc];
            } else {
                if (b[sortByAsc] - a[sortByAsc] === 0) {
                    return a[sortByDesc] - b[sortByDesc];
                }
                return b[sortByAsc] - a[sortByAsc];
            }
        });
        updateSortByDirection(!sortByDirection);
        updatePlayoffDetails([...sorted]);
    };

    return (
        <div className="seasonContainer sectionContainer">
            <h2>Playoff History</h2>
            { playoffDetails ? <>
                <table className="table table-dark table-striped">
                    <thead>
                        <tr>
                            <th scope="col" onClick={sort('name')} style={sortableHeaderStyle}>Name ⇅</th>
                            <th scope="col" onClick={sort('playoffGamesPlayed')} style={sortableHeaderStyle}>GP ⇅</th>
                            <th scope="col" onClick={sortWithTwoOptions('playoffWins', 'playoffLosses')} style={sortableHeaderStyle}>Pf W/L ⇅</th>
                            <th scope="col" onClick={sortWithTwoOptions('finalsWins', 'finalsLosses')} style={sortableHeaderStyle}><i className="trophyGold bi bi-trophy-fill"></i> W/L ⇅</th>
                            <th scope="col" onClick={sortWithTwoOptions('thirdWins', 'thirdLosses')} style={sortableHeaderStyle}><i className="trophyBronze bi bi-trophy-fill"></i> W/L ⇅</th>
                            <th scope="col" onClick={sortWithTwoOptions('semiWins', 'semiLosses')} style={sortableHeaderStyle}>Semi W/L ⇅</th>
                            <th scope="col" onClick={sortWithTwoOptions('wcWins', 'wcLosses')} style={sortableHeaderStyle}>WC W/L ⇅</th>
                            <th scope="col" style={headerStyle}>WC Byes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {playoffDetails.map((player) => (
                            <tr key={`${player.name}`}>
                                <th scope="row">{player.name}</th>
                                <td style={tdStyle}>{player.playoffGamesPlayed}</td>
                                <td style={tdStyle}>{`${player.playoffWins}-${player.playoffLosses}`}</td>
                                <td style={tdStyle}>{`${player.finalsWins}-${player.finalsLosses}`}</td>
                                <td style={tdStyle}>{`${player.thirdWins}-${player.thirdLosses}`}</td>
                                <td style={tdStyle}>{`${player.semiWins}-${player.semiLosses}`}</td>
                                <td style={tdStyle}>{`${player.wcWins}-${player.wcLosses}`}</td>
                                <td style={tdStyle}>{player.wcByes}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <h3>All-time Playoff Matchups</h3>
                <table className="table table-dark table-sm table-striped">
                    <caption className="caption-top">Row headers are the "managers", column headers are the "opponents"</caption>
                    <thead>
                        <tr>
                            <th key={`blank-theader`}>W-L</th>
                            {constants.managerList.map((managerName) => (
                                <th key={`${managerName}-theader`}>{managerName}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {constants.managerList.map((managerName) => (
                            <tr key={`${managerName}-row`}>
                                <th scope="row">{managerName}</th>
                                {constants.managerList.map((opponent) => {
                                    if (managerName === opponent) {
                                        return <td key={`${managerName}-${opponent}`} style={tdStyle}>X</td>;
                                    }
                                    if (!playoffMatchups[managerName] || !playoffMatchups[managerName][opponent]) {
                                        return <td key={`${managerName}-${opponent}`} style={tdStyle}>0-0</td>;
                                    }
                                    return <td key={`${managerName}-${opponent}`} style={tdStyle}>{playoffMatchups[managerName][opponent] ?
                                        `${playoffMatchups[managerName][opponent].wins}-${playoffMatchups[managerName][opponent].losses}` : '0-0'
                                    }</td>;
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
            : <Loader/>}
        </div>
    );
}

export default PlayoffDetailed;